<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 text-right mt-0 mt-md-4 mt-lg-0">
            <router-link
              :to="`/admin/batches/${$route.params.idBatch}/acompanhamento`"
              class="btn-link font-weight-normal text-white"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar para o painel de
              acompanhamento do batch</router-link
            >
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div
          class="col-lg-4 order-lg-1 order-md-0 vld-parent"
          ref="card_startup"
        >
          <startup-batch-info
            v-if="batch && startup"
            :startup="startup"
            :batch="batch"
            basePage="investidor"
            class="flex-grow-1"
          />
        </div>
        <div class="col-lg-8 mt-lg-0 mt-3">
          <card shadow type="secondary" bodyClasses="pb-0">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-12">
                  <h3 class="mb-0">
                    Relatório qualitativo -
                    <span class="text-warning">{{
                      startup.name || "Startup"
                    }}</span>
                  </h3>
                </div>
              </div>
            </div>
            <template>
              <div class="row">
                <div
                  class="col-lg-6 mb-4"
                  v-for="report in Object.keys(reports)"
                  :key="report"
                >
                  <card bodyClasses="pb-1">
                    <div slot="header" class="bg-white border-0">
                      <div class="row align-items-center">
                        <div class="col-12">
                          <h4 class="mb-0">
                            <i :class="[reports[report].icon, 'mr-2']"></i
                            >{{ reports[report].name }}
                          </h4>
                        </div>
                      </div>
                    </div>
                    <div
                      class="sr-container-read-only"
                      v-if="history[report][display[report]]"
                    >
                      <quill-editor
                        v-model="history[report][display[report]].answer"
                        :options="editorReadOnly"
                        disabled="disabled"
                        class="border rounded"
                      >
                      </quill-editor>
                      <p class="text-right description my-1">
                        Relatório de
                        <b>{{
                          formatDate(
                            history[report][display[report]].date,
                            "MMMM [de] YYYY"
                          )
                        }}</b>
                      </p>
                    </div>
                    <div class="text-center" v-else>
                      <badge type="warning" class="mb-3"
                        >Sem relatório para exibição.</badge
                      >
                    </div>
                    <div slot="footer">
                      <div class="text-center">
                        <base-button
                          :iconOnly="true"
                          icon="fa fa-chevron-left"
                          size="sm"
                          class="mr-0"
                          @click="previous(report)"
                          :disabled="display[report] <= 0"
                        ></base-button>
                        <span class="mx-3 text-sm"
                          >{{
                            history[report].length > 0 ? display[report] + 1 : 0
                          }}
                          / {{ history[report].length }}</span
                        >
                        <base-button
                          :iconOnly="true"
                          icon="fa fa-chevron-right"
                          size="sm"
                          class="mr-0"
                          @click="next(report)"
                          :disabled="
                            display[report] >= history[report].length - 1
                          "
                        ></base-button>
                      </div>
                    </div>
                  </card>
                </div>
              </div>
              <div class="row mb-4">
                <div
                  class="col-lg-6 vld-parent mb-4"
                  ref="considerations_container"
                >
                  <card bodyClasses="pb-1">
                    <div slot="header" class="bg-white border-0">
                      <div class="row align-items-center">
                        <div class="col-12">
                          <h4 class="mb-0">
                            <i class="fas fa-comment-dots mr-2"></i> Palavras do
                            <span class="text-warning">gestor/Stars</span>
                          </h4>
                        </div>
                      </div>
                    </div>
                    <div v-if="considerations[display.considerations]">
                      <div class="sr-container-read-only">
                        <quill-editor
                          v-model="considerations[display.considerations].text"
                          :options="editorReadOnly"
                          disabled="disabled"
                          class="border rounded"
                        >
                        </quill-editor>
                        <p class="text-right description my-1">
                          <b>{{
                            considerations[display.considerations].title
                          }}</b>
                        </p>
                      </div>
                      <div class="text-center mb-2">
                        <base-button
                          type="white"
                          :iconOnly="true"
                          icon="fas fa-edit"
                          class="text-info"
                          title="Editar palavra do gestor"
                          @click="
                            handleOpenModalEdit(
                              considerations[display.considerations]
                            )
                          "
                        ></base-button>
                        <base-button
                          type="white"
                          :iconOnly="true"
                          icon="fas fa-trash"
                          class="text-danger"
                          title="Deletar palavra do gestor"
                          @click="
                            handleOpenModalDelete(
                              considerations[display.considerations]
                            )
                          "
                        ></base-button>
                      </div>
                    </div>
                    <div class="text-center" v-else>
                      <badge type="warning" class="mb-3"
                        >Sem relatório para exibição.</badge
                      >
                    </div>
                    <div slot="footer">
                      <div class="text-center">
                        <base-button
                          :iconOnly="true"
                          icon="fa fa-chevron-left"
                          size="sm"
                          class="mr-0"
                          @click="previousConsideration()"
                          :disabled="display.considerations <= 0"
                        ></base-button>
                        <span class="mx-3 text-sm"
                          >{{
                            considerations.length > 0
                              ? display.considerations + 1
                              : 0
                          }}
                          / {{ considerations.length }}</span
                        >
                        <base-button
                          :iconOnly="true"
                          icon="fa fa-chevron-right"
                          size="sm"
                          class="mr-0"
                          @click="nextConsideration(report)"
                          :disabled="
                            display.considerations >= considerations.length - 1
                          "
                        ></base-button>
                      </div>
                    </div>
                  </card>
                </div>
                <div class="col-lg-6 vld-parent" ref="considerations_form">
                  <card bodyClasses="pb-0" footerClasses="py-2">
                    <template>
                      <div class="sr-container-edditable">
                        <base-input
                          label="Título"
                          v-model="model.title"
                          :placeholder="placeholder"
                        />
                        <base-input label="Palavra do gestor/Stars">
                          <quill-editor
                            v-model="model.text"
                            :options="editorEdittable"
                          >
                          </quill-editor>
                        </base-input>
                      </div>
                    </template>
                    <div slot="footer" class="text-center">
                      <base-button
                        type="primary"
                        :disabled="!isValidModel"
                        @click="handleSaveConsiderations"
                        >Salvar</base-button
                      >
                    </div>
                  </card>
                </div>
              </div>
            </template>
          </card>
        </div>
      </div>
    </div>
    <modal
      :show.sync="modals.edit.show"
      modal-classes="modal-dialog-centered"
      body-classes="pb-0"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Atualização
      </h6>
      <div class="vld-parent" ref="modal_edit">
        <div class="text-center">
          <i class="fa fa-edit fa-3x"></i>
          <h4 class="heading mt-4">
            Atualizar palavra do <span class="text-warning">gestor/Stars</span>
          </h4>
        </div>
        <div class="sr-container-edditable">
          <base-input
            label="Título"
            v-model="modals.edit.model.title"
            :placeholder="placeholder"
          />
          <base-input label="Palavra do gestor/Stars">
            <quill-editor
              v-model="modals.edit.model.text"
              :options="editorEdittable"
            >
            </quill-editor>
          </base-input>
        </div>
        <div class="text-center" v-if="modals.edit.error">
          <base-alert type="danger"
            >Ocorreu um erro ao atualizar a palavra do gestor. Por favor, tente
            novamente.</base-alert
          >
        </div>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="default"
          class="ml-auto"
          @click="modals.edit.show = false"
        >
          Voltar
        </base-button>
        <base-button
          type="primary"
          @click="handleUpdateConsideration"
          :disabled="!isValidEditModel"
        >
          Salvar alterações
        </base-button>
      </template>
    </modal>
    <modal
      :show.sync="modals.delete.show"
      gradient="dark"
      modal-classes="modal-danger modal-dialog-centered"
      body-classes="pb-0"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Atenção!
      </h6>
      <div class="vld-parent" ref="modal_confirmation_delete">
        <div class="pb-4 text-center">
          <i class="fa fa-trash fa-3x"></i>
          <h4 class="heading mt-4">
            Você realmente deseja excluir esse relatório?
          </h4>
          <p class="mt-3 mb-0">
            A palavra do gestor entitulada
            <b>{{ modals.delete.consideration.title }}</b> será removida.
          </p>
        </div>
        <div class="text-center" v-if="modals.delete.error">
          <base-alert type="danger"
            >Ocorreu um erro ao remover a palavra do gestor. Por favor, tente
            novamente.</base-alert
          >
        </div>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="white"
          class="ml-auto"
          @click="modals.delete.show = false"
        >
          Voltar
        </base-button>
        <base-button
          type="white"
          class="text-danger"
          @click="handleDeleteConsideration"
        >
          Confirmar exclusão
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import StartupBatchInfo from "@/components/StartupDashboard/StartupBatchInfo";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

import api from "@/services/api.js";

export default {
  components: {
    StartupBatchInfo,
    quillEditor,
  },
  data() {
    return {
      model: {
        title: "",
        text: "",
      },
      batch: "",
      startup: "",
      considerations: [],
      reports: {
        achievements: {
          name: "Principais conquistas",
          icon: "fas fa-trophy",
        },
        opportunities: {
          name: "Principais oportunidades",
          icon: "fas fa-lightbulb",
        },
        challenges: {
          name: "Principais desafios",
          icon: "fas fa-exclamation-triangle",
        },
        next_steps: { name: "Próximos passos", icon: "fas fa-shoe-prints" },
      },
      display: {
        achievements: 0,
        opportunities: 0,
        next_steps: 0,
        challenges: 0,
        considerations: 0,
      },
      history: {
        achievements: [],
        opportunities: [],
        next_steps: [],
        challenges: [],
      },
      editorReadOnly: {
        placeholder: "N/A",
        readOnly: true,
        theme: "bubble",
      },
      editorEdittable: {
        placeholder: "Escreva aqui...",
      },
      modals: {
        edit: {
          show: false,
          model: {
            title: "",
            text: "",
          },
          consideration: "",
          error: "",
        },
        delete: {
          show: false,
          consideration: "",
          error: "",
        },
      },
    };
  },
  async mounted() {
    const loader = this.$loading.show({
      container: this.$refs.card_startup,
      width: 140,
      height: 140,
      opacity: 0,
    });
    await this.loadStartupReports();
    loader.hide();
    await this.loadConsiderations();
  },
  methods: {
    async loadStartupReports() {
      try {
        const { data } = await api.get(
          `/batches/${this.$route.params.idBatch}/startups/${this.$route.params.idStartup}/metrics?only_qualitative=true`
        );
        if (!data.batch) throw new Error("Batch not found");
        if (!data.startup) throw new Error("Startup not found");
        this.batch = data.batch;
        this.startup = data.startup;
        const defaultLogoPath = "/img/pages/default_logo.png";
        if (!this.startup.logo) this.startup.logo = { url: defaultLogoPath };
        this.prepareData(data.startup.responses);
        return;
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao carregar informações");
        this.$router.push(
          `/admin/batches/${this.$route.params.idBatch}/acompanhamento`
        );
      }
    },
    prepareData(data) {
      this.splitResponsesByFamily(data);
    },
    splitResponsesByFamily(responses) {
      responses.forEach((response) => {
        if (response.family in this.history)
          this.history[response.family].push({
            answer: response.answer_text,
            date: response.start_date,
            visible: response.visible === undefined || response.visible,
          });
      });
    },
    next(reportName) {
      if (this.history[reportName].length - 1 > this.display[reportName])
        this.display[reportName]++;
    },
    previous(reportName) {
      if (this.display[reportName] > 0) this.display[reportName]--;
    },
    nextConsideration() {
      if (this.considerations.length - 1 > this.display.considerations)
        this.display.considerations++;
    },
    previousConsideration() {
      if (this.display.considerations > 0) this.display.considerations--;
    },
    async loadConsiderations() {
      const loader = this.$loading.show({
        container: this.$refs.considerations_container,
        width: 140,
        height: 140,
      });
      try {
        const { data } = await api.get(
          `/batches/${this.batch.id}/startups/${this.startup.user_id}/considerations`
        );
        this.considerations = data;
        this.display.considerations = 0;
        loader.hide();
      } catch (e) {
        this.$toasted.error(
          "Ocorreu um erro ao recuperar as palavras do gestor"
        );
      }
    },
    async handleSaveConsiderations() {
      const loader = this.$loading.show({
        container: this.$refs.considerations_form,
        width: 140,
        height: 140,
      });
      try {
        await api.post(
          `/batches/${this.batch.id}/startups/${this.startup.user_id}/considerations`,
          this.model
        );
        this.$toasted.success("Palavra do gestor salva com sucesso!");
        this.model.text = this.model.title = "";
        await this.loadConsiderations();
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao salvar a palavra do gestor");
      } finally {
        loader.hide();
      }
    },
    handleOpenModalEdit(consideration) {
      this.modals.edit.error = "";
      this.modals.edit.model.title = consideration.title;
      this.modals.edit.model.text = consideration.text;
      this.modals.edit.consideration = consideration;
      this.modals.edit.show = true;
    },
    handleOpenModalDelete(consideration) {
      this.modals.delete.error = "";
      this.modals.delete.consideration = consideration;
      this.modals.delete.show = true;
    },
    async handleUpdateConsideration() {
      this.modals.edit.error = "";
      const loader = this.$loading.show({
        container: this.$refs.modal_edit,
        width: 140,
        height: 140,
      });
      try {
        await api.put(
          `/batches/${this.batch.id}/startups/${this.startup.user_id}/considerations/${this.modals.edit.consideration.id}`,
          this.modals.edit.model
        );
        this.$toasted.success("Palavra do gestor atualizada com sucesso!");
        this.modals.edit.show = false;
        await this.loadConsiderations();
      } catch (e) {
        this.modals.edit.error = true;
        this.$toasted.error("Ocorreu um erro ao atualizar a palavra do gestor");
      } finally {
        loader.hide();
      }
    },
    async handleDeleteConsideration() {
      this.modals.delete.error = "";
      const loader = this.$loading.show({
        container: this.$refs.modal_confirmation_delete,
        width: 160,
        height: 160,
        opacity: 0,
      });
      try {
        await api.delete(
          `/batches/${this.batch.id}/startups/${this.startup.user_id}/considerations/${this.modals.delete.consideration.id}`
        );
        this.$toasted.show("Palavra do gestor removida com sucesso");
        this.modals.delete.show = false;
        await this.loadConsiderations();
      } catch (e) {
        this.modals.delete.error = true;
        this.$toasted.error("Ocorreu um erro ao remover a palavra do gestor.");
      } finally {
        loader.hide();
      }
    },
  },
  computed: {
    placeholder() {
      return `Ex. ${this.formatDate(this.moment(), "MMMM [de] YYYY")}`;
    },
    isValidModel() {
      return this.model.text !== "" && this.model.title !== "";
    },
    isValidEditModel() {
      return (
        this.modals.edit.model.text !== "" && this.modals.edit.title !== ""
      );
    },
  },
};
</script>
<style scoped>
.card-image {
  width: 180px;
  height: 180px;
  border-radius: 10%;
  margin: auto;
}
</style>
<style>
p > strong {
  font-weight: bold !important;
}

.sr-container-read-only .quill-editor .ql-container,
.sr-container-read-only .quill-editor .ql-container .ql-editor {
  max-height: 400px;
  min-height: 150px;
  width: 100%;
}

.sr-container-edditable .quill-editor .ql-container,
.sr-container-edditable .quill-editor .ql-container .ql-editor {
  height: 9rem;
  width: 100%;
}
</style>
